import React from 'react';
import { useSelector } from 'react-redux';

import { bikeSummaryAccessoriesSelector } from 'src/redux/bike/selectors';

import ItemWrapper from 'components/BikeSummaryItem/BikeSummaryItem';
import Label from 'components/_utility/Label';
import { Section, Header, HeaderTitle } from './SummaryAccessoryCard.styled';

const SummaryAccessoryCard = () => {
  const accessories = useSelector(bikeSummaryAccessoriesSelector);

  return (
    <Section>
      <Header>
        <HeaderTitle>
          <Label name="accessoriesLabel" />
        </HeaderTitle>
      </Header>
      {accessories.length
        ? accessories.map((accessory, index) => (
            <ItemWrapper
              key={index}
              name={accessory.name}
              price={accessory.price}
              priceLocalised={accessory.priceLocalised}
              fittingTime={accessory.fittingTime}
              image={accessory.images[0]}
              id={accessory.id}
              quantity={accessory.quantity}
              isAccessories
              allowMultiple={accessory.allowMultiple}
              categoryId={accessory.categoryId}
              partNumber={accessory.partNumber}
            />
          ))
        : null}
    </Section>
  );
};

export default SummaryAccessoryCard;
